import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBolt } from '@fortawesome/pro-solid-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { QualificationTrainingProviderType } from '@wilson/interfaces';
import { NzTagModule } from 'ng-zorro-antd/tag';

interface Provider {
  name: string;
  providerType: QualificationTrainingProviderType;
}

@Component({
  selector: 'wilson-qualification-training-provider-tag',
  template: `
    @if (provider.providerType === QualificationTrainingProviderType.Digital) {
      <nz-tag
        [style.backgroundColor]="'#87E0BB1A'"
        [style.borderColor]="'var(--wilson)'"
        [style.color]="'var(--dark)'"
      >
        {{ provider.name }}
        <fa-icon
          [icon]="faBolt"
          class="ms-1"
          [style.color]="'var(--wilson)'"
        ></fa-icon>
      </nz-tag>
    } @else {
      <nz-tag>
        {{ provider.name }}
      </nz-tag>
    }
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, NzTagModule, FontAwesomeModule],
})
export class QualificationTrainingProviderTagComponent {
  @Input() provider!: Provider;

  protected QualificationTrainingProviderType =
    QualificationTrainingProviderType;
  protected faBolt = faBolt;
}
